import { Info } from "@phosphor-icons/react";
import clsx from "clsx";

export default function SettingsBanner({
  variant,
  text,
  actionComponent,
}: {
  variant: "default" | "warning";
  text: string;
  actionComponent: JSX.Element;
}) {
  return (
    <div
      className={clsx(
        "px-4 py-3 border rounded-3xl flex items-start gap-x-2",
        variant === "default" ? "border-purple-400" : "border-yellow-400",
      )}
    >
      <Info weight="fill" className="size-4" />
      <p className="text-xs">{text}</p>
      {actionComponent}
    </div>
  );
}
